import permissions from '../../permissions'

const CLIENT_PROFILE_LIST = [
  {
    name: permissions.PERMISSIONS_DEFAULT_LABEL.LIST,
    tag: permissions.CLIENT_PROFILES.LIST,
  },
  {
    name: permissions.PERMISSIONS_DEFAULT_LABEL.CREATE,
    tag: permissions.CLIENT_PROFILES.CREATE,
  },
  {
    name: permissions.PERMISSIONS_DEFAULT_LABEL.EDIT,
    tag: permissions.CLIENT_PROFILES.EDIT,
  },
  {
    name: permissions.PERMISSIONS_DEFAULT_LABEL.ACTIVATE_OR_INACTIVATE,
    tag: permissions.CLIENT_PROFILES.CHANGE_STATUS,
  },
]

export default CLIENT_PROFILE_LIST
